<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3 v-if="editKombox.id">{{'Kombox bearbeiten'}}</h3>
              <h3 v-else>{{'Neue Kombox anlegen'}}</h3>
               
              <div v-if="false">
                 <!-- DEBUGG -->
                 idCompany: {{editKombox.idCompany}}
                 idUser: {{editKombox.idUser}}
               </div>
               
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form @keyup.esc="$emit('cancel', kombox)" @submit.prevent="onSubmit" :id="_uid">
                 <div class="form-group">
                  <label for="kombox-type">Art :</label>
                  <select required id="kombox-type" class="form-control text-right" v-model="editKombox.type">
                    <option v-for="option in KomboxConf.TYPES"
                      v-bind:value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                
                <div v-show="['2','3','8','10'].indexOf(editKombox.type) > -1" class="form-group" style="padding-left: 20px">
                  <select id="kombox-sub-type" class="form-control text-right" v-model="editKombox.subType">
                    <option v-for="option in KomboxConf.SUBTYPES"
                      :value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                <div v-if="['8','9','10'].indexOf(editKombox.type) > -1" class="form-group" style="padding-left: 20px">
                  <label for="zeiten">Zeiten :</label>
                  <input type="" class="form-control" id="zeiten" placeholder="13:00, 16:00, ..." pattern="^(([0-1][0-9])|(2[0-3])):[0-5][0-9](,[ ]?(([0-1][0-9])|(2[0-3])):[0-5][0-9])*" v-model="editKombox.validTimes">
                </div>
                
                <div class="form-group">
                  <label for="acl">Rechte :</label>
                  <select id="acl" class="form-control text-right" v-model="editKombox.acl">
                    <option v-for="option in KomboxConf.ACLS" 
                      :value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label for="kb-modal-content">Inhalt :</label>
                  <input v-focus required
                    id="kb-modal-content"
                    class="form-control"
                    type="text"
                    :pattern="KomboxConf.TYPES[editKombox.type].CONTENT.PATTERN"
                    :placeholder="KomboxConf.TYPES[editKombox.type].CONTENT.PLACEHOLDER"
                    :title="KomboxConf.TYPES[editKombox.type].CONTENT.PLACEHOLDER"
                    v-model="editKombox.content" >
                </div>
                
                <div class="form-group">
                  <label for="beschreibung">Beschreibung :</label>
                  <input type="" class="form-control" id="beschreibung" placeholder="Tel" v-model="editKombox.description">
                </div>
                
                <div class="form-group">
                  <label for="cc-versand">Versand :</label>
                  <select id="cc-versand" class="form-control text-right" v-model="editKombox.shippingActiv">
                    <option v-for="option in KomboxConf.SHIPPING_ACTIV"
                      :value="option.OPTION.VALUE"
                      v-text="option.OPTION.TEXT">
                    </option>
                  </select>
                </div>
                
                <div v-show="editKombox.shippingActiv > 0" class="form-group">
                  <label for="cc-datetime-shipping-begin">Versandbeginn :</label>
                  <cc-datetime label_id="cc-datetime-shipping-begin" v-model="editKombox.datetimeShippingBegin"></cc-datetime>
                </div>
                
                <div v-show="editKombox.shippingActiv > 0" class="form-group">
                  <label for="cc-datetime-shipping-end">Versandende :</label>
                  <cc-datetime label_id="cc-datetime-shipping-end" v-model="editKombox.datetimeShippingEnd"></cc-datetime>
                </div>

                <div class="form-group">
                  <label for="cc-datetime-begin">Beginn :</label>
                  <cc-datetime label_id="cc-datetime-begin" v-model="editKombox.datetimeBegin"></cc-datetime>
                </div>
                
                <div class="form-group">
                  <label for="cc-datetime-end">Ende :</label>
                  <cc-datetime label_id="cc-datetime-end" v-model="editKombox.datetimeEnd"></cc-datetime>
                </div>
                
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
               
              <button type="submit"
                :form="_uid"
                class="btn btn-primary">
                Speichern
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('cancel', kombox)">
                Abbrechen
              </button>

              <button type="" 
                v-if="editKombox.id" 
                class="btn btn-danger"   
                @click="$emit('remove', kombox)">
                Löschen
              </button>
              
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

//import bus from './common/bus'
import KomboxCommon from './common/kombox.common'
import DateTime from './helper/datetime.vue'

export default {
  
  extends: KomboxCommon,
  
  components: {
    'cc-datetime': DateTime,
  },  
  
  data () {
    return {
      editKombox: JSON.parse(JSON.stringify(this.kombox)),
    }
  },
  
  mounted: function () {
  },
  
  created: function () {
  },
  
  computed: {
  },  
  
  
  methods: {

    onSubmit: function () {
      if(_.isEqual(this.kombox, this.editKombox)){
        // keine Änderung, speichern nicht notwendig
        this.$emit('cancel', this.kombox)
      }else{
        // speichern
        this.$emit('save', this.editKombox)
      }
    },

    
  },
}
  
</script>



<style scoped>

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 60vh;
  /*margin: 0px auto;*/
  margin-left: 15%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  height:50vh;
  margin: 20px 0;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

input:invalid {
  border: 1px solid red;
}  

</style>



// WEBPACK FOOTER //
// KomboxModal.vue?50a3155e